import { Component, Output, EventEmitter, Input, OnInit } from '@angular/core';
import { District } from '../../interfaces/game.interface';
import { Observable } from 'rxjs';
import { DataService } from '../../services/data.service';

@Component({
  selector: 'app-district-info-page',
  templateUrl: './district-info-page.component.html',
  styleUrls: ['./district-info-page.component.scss']
})
export class DistrictInfoPageComponent implements OnInit {
  @Input() district: string;
  @Output() closeClick = new EventEmitter<void>();
  districtDetails$: Observable<District>;

  districtMap = {
    "Retail": {
      color: '#00D6E0',
      colorName: 'blue'
    },
    "University": {
      color: '#FF8100',
      colorName: 'orange'
    },
    "Industrial": {
      color: '#EA4E6C',
      colorName: 'pink'
    },
    "Suburban": {
      color: '#00D398',
      colorName: 'green'
    },
    "Shopping Centre": {
      color: '#F15B3D',
      colorName: 'red'
    }
  }
  
  constructor(private dataService: DataService) {}

  ngOnInit(): void {
    this.districtDetails$ = this.dataService.getDistrictObservable(this.district);
  }

  onCloseClick(): void {
    this.closeClick.emit();
  }
}
